const getTypeOfKPI = (initiative) => {
    if (!initiative || !initiative.KPI || initiative.KPI.length === 0) {
      return [];
    }
  
    const universalNames = [];
    const seenUniversal = new Set();
  
    for (const kpiItem of initiative.KPI) {
      const name = kpiItem?.TypeOfKPI;
  
      if (name && !seenUniversal.has(name)) {
        universalNames.push(name);
        seenUniversal.add(name);
      }
    }
  
    return universalNames;
  };
  
  export default getTypeOfKPI;